/**
 * A cross-subdomain login hint for the marketing site (www.geekfun.club).
 * Presentational ONLY: the site header reads it to swap "Log in" for
 * "Console" — every real auth decision still lives in the console API
 * (the service worker of this app keeps the actual session).
 *
 * Both console.geekfun.club and www.geekfun.club sit under geekfun.club,
 * so a cookie scoped to the registrable domain is readable by both.
 */
const COOKIE_NAME = 'gfc_auth'
const COOKIE_DOMAIN = '.geekfun.club'
const COOKIE_MAX_AGE = 60 * 60 * 24 * 7 // a week — matches the refresh-token horizon

const writeHintCookie = (maxAgeSeconds: number): void => {
  if (typeof document === 'undefined') return
  document.cookie = `${COOKIE_NAME}=1; domain=${COOKIE_DOMAIN}; path=/; max-age=${maxAgeSeconds}; samesite=lax`
}

/** Called on every successful login/registration and token refresh. */
export const markAuthHint = (): void => writeHintCookie(COOKIE_MAX_AGE)

/** Called on logout, token invalidation and session collapse. */
export const clearAuthHint = (): void => writeHintCookie(0)
